import EventCard from './event-card';

export default EventCard;
